import { http, HttpResponse } from 'msw';

const baseUrl = `${process.env.NEXT_PUBLIC_API_BASE_URL}/users`;

export const usersHandlers = [
  // TODO: ダッシュボード実装時に、ヘッダー表示に必要な情報を設定
  // 自身の情報取得
  http.get(`${baseUrl}/me`, (_) => {
    return HttpResponse.json({ id: 1, email: 'dummy@signate.com' });
    // return HttpResponse.json(
    //   { error_type: 'error', message: 'サインインしてください' },
    //   { status: 401 }
    // );
    // return HttpResponse.json(
    //   { error_type: 'error', message: 'アクセス権限がありません' },
    //   { status: 403 }
    // );
    // return HttpResponse.json(
    //   { error_type: 'error', message: 'システムエラーが発生しました' },
    //   { status: 500 }
    // );
  }),
  // パスワード変更
  http.put(`${baseUrl}/me/password`, async ({ request }) => {
    const usersMePasswordRequest = (await request.json()) as Required<{
      current_password: string;
      password: string;
      password_confirmation: string;
    }>;
    console.table(usersMePasswordRequest);

    if (usersMePasswordRequest.password === 'errorpass') {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'password',
              message: '新しいパスワードを正しい形式で入力してください。',
            },
          ],
        },
        { status: 400 }
      );
    } else if (usersMePasswordRequest.current_password === 'password') {
      return HttpResponse.json({ success: true });
    } else {
      return HttpResponse.json(
        {
          error_type: 'form_error',
          details: [
            {
              field: 'current_password',
              message: 'パスワードが間違っています。',
            },
          ],
        },
        { status: 401 }
      );
    }
  }),
];
